const moment = require('moment-timezone');

const timezoneNames = {
	'Etc/GMT+12': 'International Date Line West',
	'Pacific/Midway': 'Midway Island, Samoa',
	'Pacific/Honolulu': 'Hawaii',
	'US/Alaska': 'Alaska',
	'America/Los_Angeles': 'Pacific Time (US & Canada)',
	'America/Tijuana': 'Tijuana, Baja California',
	'US/Arizona': 'Arizona',
	'America/Chihuahua': 'Chihuahua, La Paz, Mazatlan',
	'US/Mountain': 'Mountain Time (US & Canada)',
	'America/Managua': 'Central America',
	'US/Central': 'Central Time (US & Canada)',
	'America/Mexico_City': 'Guadalajara, Mexico City, Monterrey',
	'Canada/Saskatchewan': 'Saskatchewan',
	'America/Bogota': 'Bogota, Lima, Quito, Rio Branco',
	'US/Eastern': 'Eastern Time (US & Canada)',
	'US/East-Indiana': 'Indiana (East)',
	'Canada/Atlantic': 'Atlantic Time (Canada)',
	'America/Caracas': 'Caracas, La Paz',
	'America/Manaus': 'Manaus',
	'America/Santiago': 'Santiago',
	'Canada/Newfoundland': 'Newfoundland',
	'America/Sao_Paulo': 'Brasilia',
	'America/Argentina/Buenos_Aires': 'Buenos Aires, Georgetown',
	'America/Godthab': 'Greenland',
	'America/Montevideo': 'Montevideo',
	'America/Noronha': 'Mid-Atlantic',
	'Atlantic/Cape_Verde': 'Cape Verde Is.',
	'Atlantic/Azores': 'Azores',
	'Africa/Casablanca': 'Casablanca, Monrovia, Reykjavik',
	'Etc/Greenwich': 'Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London',
	'Europe/Amsterdam': 'Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
	'Europe/Belgrade': 'Belgrade, Bratislava, Budapest, Ljubljana, Prague',
	'Europe/Brussels': 'Brussels, Copenhagen, Madrid, Paris',
	'Europe/Sarajevo': 'Sarajevo, Skopje, Warsaw, Zagreb',
	'Africa/Lagos': 'West Central Africa',
	'Asia/Amman': 'Amman',
	'Europe/Athens': 'Athens, Bucharest, Istanbul',
	'Asia/Beirut': 'Beirut',
	'Africa/Cairo': 'Cairo',
	'Africa/Harare': 'Harare, Pretoria',
	'Europe/Helsinki': 'Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius',
	'Asia/Jerusalem': 'Jerusalem',
	'Europe/Minsk': 'Minsk',
	'Africa/Windhoek': 'Windhoek',
	'Asia/Kuwait': 'Kuwait, Riyadh, Baghdad',
	'Europe/Moscow': 'Moscow, St. Petersburg, Volgograd',
	'Africa/Nairobi': 'Nairobi',
	'Asia/Tbilisi': 'Tbilisi',
	'Asia/Tehran': 'Tehran',
	'Asia/Muscat': 'Abu Dhabi, Muscat',
	'Asia/Baku': 'Baku',
	'Asia/Yerevan': 'Yerevan',
	'Asia/Kabul': 'Kabul',
	'Asia/Yekaterinburg': 'Yekaterinburg',
	'Asia/Karachi': 'Islamabad, Karachi, Tashkent',
	'Asia/Calcutta': 'Chennai, Kolkata, Mumbai, New Delhi',
	'Asia/Katmandu': 'Kathmandu',
	'Asia/Almaty': 'Almaty, Novosibirsk',
	'Asia/Dhaka': 'Astana, Dhaka',
	'Asia/Rangoon': 'Yangon (Rangoon)',
	'Asia/Bangkok': 'Bangkok, Hanoi, Jakarta',
	'Asia/Krasnoyarsk': 'Krasnoyarsk',
	'Asia/Hong_Kong': 'Beijing, Chongqing, Hong Kong, Urumqi',
	'Asia/Kuala_Lumpur': 'Kuala Lumpur, Singapore',
	'Asia/Irkutsk': 'Irkutsk, Ulaan Bataar',
	'Australia/Perth': 'Perth',
	'Asia/Taipei': 'Taipei',
	'Asia/Tokyo': 'Osaka, Sapporo, Tokyo',
	'Asia/Seoul': 'Seoul',
	'Asia/Yakutsk': 'Yakutsk',
	'Australia/Adelaide': 'Adelaide',
	'Australia/Darwin': 'Darwin',
	'Australia/Brisbane': 'Brisbane',
	'Australia/Canberra': 'Canberra, Melbourne, Sydney',
	'Australia/Hobart': 'Hobart',
	'Pacific/Guam': 'Guam, Port Moresby',
	'Asia/Vladivostok': 'Vladivostok',
	'Asia/Magadan': 'Magadan, Solomon Is., New Caledonia',
	'Pacific/Auckland': 'Auckland, Wellington',
	'Pacific/Fiji': 'Fiji, Kamchatka, Marshall Is.',
	'Pacific/Tongatapu': "Nuku'alofa",
};

const timezones = Object.keys(timezoneNames).reduce(
	(acc, key) => ({
		...acc,
		[key]: `(GMT${moment().tz(key).format().slice(-6)}) ${timezoneNames[key]}`,
	}),
	{}
);

export const links = {
	customer: {
		text: 'ЛК клиента',
		title: 'Персональный раздел клиента',
		href: '#',
	},
	admin: {
		text: 'Работа с клиентом',
		title: 'Данные клиента, доступные администратору',
		href: '#',
	},
	index: {
		text: 'Список клиентов',
		title: 'Основной административный раздел',
		href: '#',
	},
};

export const defaultLink =
	'https://zoom.us/j/7045752008?pwd=MlNMbEg4UXpVQkRXdHNQNmxielcyQT09';
export const defaultDetails =
	'Please follow the link below to join consultation Zoom meeting:';

export const initialStructured = {
	education: { 0: {} },
	experience: { 0: {} },
	spouse: {
		education: { 0: {} },
		experience: { 0: {} },
	},
	sponsor: {
		education: { 0: {} },
		experience: { 0: {} },
	},
	sponsored: {
		education: { 0: {} },
		experience: { 0: {} },
	},
	ext: {
		0: {
			education: { 0: {} },
			experience: { 0: {} },
			adresses: { 0: {} },
			trips: { 0: {} },
			relatives: { 0: {} },
		},
	},
};

const servicesData = {
	spFull: 'SP Full',
	sp: 'SP',
	adm: 'Admissions',
	wp: 'WP',
	trv: 'TRV',
	ee: 'EE',
	pnp: 'PNP',
	ss: 'SS',
	ps: 'PS',
	pgwp: 'PGWP',
	rehab: 'Rehab',
	cons: 'Consultation',
	ext: 'Ext',
	other: 'Other',
	wes: 'WES',
	owp: 'OWP',
	suv: 'SUV',
	aip: 'AIP',
	p1: 'Program 1',
	p2: 'Program 2',
	sv: 'SV',
	hc: 'HC',
	rest: 'Rest',
	cz: 'CZ',
	ab: 'AB',
	bc: 'BC',
	mb: 'MB',
	nb: 'NB',
	nl: 'NL',
	ns: 'NS',
	on: 'ON',
	pe: 'PE',
	nt: 'NT',
	yt: 'YT'
};

export const services = Object.keys(servicesData).sort().reduce((acc, key) => ({...acc, [key]: servicesData[key]}), {})

export const extendedServices = ['ee', 'pnp', 'ab', 'bc', 'mb', 'nb', 'nl', 'ns', 'on', 'pe', 'nt', 'yt'];

export const twoStageServices = ['spFull', ...extendedServices];

export const docTitles = {
	spFull:
		'ЧЕК-ЛИСТ для сбора документов и необходимой информации (студенческая виза и разрешение на работу)',
	sp: 'ЧЕК-ЛИСТ для сбора документов и необходимой информации (студенческая виза и разрешение на работу)',
	adm: 'ЧЕК-ЛИСТ для сбора документов Admissions',
	wp: 'ЧЕК-ЛИСТ для сбора документов WP',
	trv: 'ЧЕК-ЛИСТ для сбора документов и необходимой информации для подачи на временную визу Канады',
	ee: 'ЧЕК-ЛИСТ для сбора документов и необходимой информации для иммиграции через систему Express Entry',
	pnp: 'ЧЕК-ЛИСТ для сбора документов и необходимой информации для иммиграции через систему Express Entry',
	ss: 'CHECKLIST of documents and necessary information to sponsor a spouse to Canada',
	ps: 'ЧЕК-ЛИСТ для сбора документов PS',
	pgwp: 'ЧЕК-ЛИСТ для сбора документов PGWP',
	rehab: 'ЧЕК-ЛИСТ для сбора документов Rehab',
	cons: 'ЧЕК-ЛИСТ для сбора документов Consultation',
	ext: 'ЧЕК-ЛИСТ продления разрешения на учебу внутри Канады',
	other: 'ЧЕК-ЛИСТ для сбора документов Other',
	owp: 'ЧЕК-ЛИСТ для сбора документов OWP',
	suv: 'ЧЕК-ЛИСТ для сбора документов SUV',
};

export const adminPic =
	'https://cdn4.vectorstock.com/i/thumb-large/52/38/avatar-icon-vector-11835238.jpg';

export const userPic =
	'https://images.unsplash.com/photo-1493666438817-866a91353ca9?ixlib=rb-0.3.5&q=80&fm=jpg&crop=faces&fit=crop&h=200&w=200&s=b616b2c5b373a80ffc9636ba24f7a4a9';

export const sessionKey = 'HMAUpQ>&4$5zjnt5';

export const options = () => ({
	headers: { 'X-Auth': localStorage.getItem(sessionKey) },
});

export const selectOptions = {
	consTimezones: {
		'Etc/GMT+5': '(GMT-05:00) Winter',
		'Etc/GMT+4': '(GMT-04:00) Summer',
	},
	timezones,
	countries: {
		DZ: 'Algeria (+213)',
		AD: 'Andorra (+376)',
		AO: 'Angola (+244)',
		AI: 'Anguilla (+1264)',
		AG: 'Antigua &amp; Barbuda (+1268)',
		AR: 'Argentina (+54)',
		AM: 'Armenia (+374)',
		AW: 'Aruba (+297)',
		AU: 'Australia (+61)',
		AT: 'Austria (+43)',
		AZ: 'Azerbaijan (+994)',
		BS: 'Bahamas (+1242)',
		BH: 'Bahrain (+973)',
		BD: 'Bangladesh (+880)',
		BB: 'Barbados (+1246)',
		BY: 'Belarus (+375)',
		BE: 'Belgium (+32)',
		BZ: 'Belize (+501)',
		BJ: 'Benin (+229)',
		BM: 'Bermuda (+1441)',
		BT: 'Bhutan (+975)',
		BO: 'Bolivia (+591)',
		BA: 'Bosnia Herzegovina (+387)',
		BW: 'Botswana (+267)',
		BR: 'Brazil (+55)',
		BN: 'Brunei (+673)',
		BG: 'Bulgaria (+359)',
		BF: 'Burkina Faso (+226)',
		BI: 'Burundi (+257)',
		KH: 'Cambodia (+855)',
		CM: 'Cameroon (+237)',
		CA: 'Canada (+1)',
		CV: 'Cape Verde Islands (+238)',
		KY: 'Cayman Islands (+1345)',
		CF: 'Central African Republic (+236)',
		CL: 'Chile (+56)',
		CN: 'China (+86)',
		CO: 'Colombia (+57)',
		KM: 'Comoros (+269)',
		CG: 'Congo (+242)',
		CK: 'Cook Islands (+682)',
		CR: 'Costa Rica (+506)',
		HR: 'Croatia (+385)',
		CU: 'Cuba (+53)',
		CYN: 'Cyprus North (+90392)',
		CY: 'Cyprus South (+357)',
		CZ: 'Czech Republic (+42)',
		DK: 'Denmark (+45)',
		DJ: 'Djibouti (+253)',
		DM: 'Dominica (+1809)',
		DO: 'Dominican Republic (+1809)',
		EC: 'Ecuador (+593)',
		EG: 'Egypt (+20)',
		SV: 'El Salvador (+503)',
		GQ: 'Equatorial Guinea (+240)',
		ER: 'Eritrea (+291)',
		EE: 'Estonia (+372)',
		ET: 'Ethiopia (+251)',
		FK: 'Falkland Islands (+500)',
		FO: 'Faroe Islands (+298)',
		FJ: 'Fiji (+679)',
		FI: 'Finland (+358)',
		FR: 'France (+33)',
		GF: 'French Guiana (+594)',
		PF: 'French Polynesia (+689)',
		GA: 'Gabon (+241)',
		GM: 'Gambia (+220)',
		GE: 'Georgia (+7880)',
		DE: 'Germany (+49)',
		GH: 'Ghana (+233)',
		GI: 'Gibraltar (+350)',
		GR: 'Greece (+30)',
		GL: 'Greenland (+299)',
		GD: 'Grenada (+1473)',
		GP: 'Guadeloupe (+590)',
		GU: 'Guam (+671)',
		GT: 'Guatemala (+502)',
		GN: 'Guinea (+224)',
		GW: 'Guinea - Bissau (+245)',
		GY: 'Guyana (+592)',
		HT: 'Haiti (+509)',
		HN: 'Honduras (+504)',
		HK: 'Hong Kong (+852)',
		HU: 'Hungary (+36)',
		IS: 'Iceland (+354)',
		IN: 'India (+91)',
		ID: 'Indonesia (+62)',
		IR: 'Iran (+98)',
		IQ: 'Iraq (+964)',
		IE: 'Ireland (+353)',
		IL: 'Israel (+972)',
		IT: 'Italy (+39)',
		JM: 'Jamaica (+1876)',
		JP: 'Japan (+81)',
		JO: 'Jordan (+962)',
		KZ: 'Kazakhstan (+7)',
		KE: 'Kenya (+254)',
		KI: 'Kiribati (+686)',
		KP: 'Korea North (+850)',
		KR: 'Korea South (+82)',
		KW: 'Kuwait (+965)',
		KG: 'Kyrgyzstan (+996)',
		LA: 'Laos (+856)',
		LV: 'Latvia (+371)',
		LB: 'Lebanon (+961)',
		LS: 'Lesotho (+266)',
		LR: 'Liberia (+231)',
		LY: 'Libya (+218)',
		LI: 'Liechtenstein (+417)',
		LT: 'Lithuania (+370)',
		LU: 'Luxembourg (+352)',
		MO: 'Macao (+853)',
		MK: 'Macedonia (+389)',
		MG: 'Madagascar (+261)',
		MW: 'Malawi (+265)',
		MY: 'Malaysia (+60)',
		MV: 'Maldives (+960)',
		ML: 'Mali (+223)',
		MT: 'Malta (+356)',
		MH: 'Marshall Islands (+692)',
		MQ: 'Martinique (+596)',
		MR: 'Mauritania (+222)',
		YT: 'Mayotte (+269)',
		MX: 'Mexico (+52)',
		FM: 'Micronesia (+691)',
		MD: 'Moldova (+373)',
		MC: 'Monaco (+377)',
		MN: 'Mongolia (+976)',
		MS: 'Montserrat (+1664)',
		MA: 'Morocco (+212)',
		MZ: 'Mozambique (+258)',
		MNM: 'Myanmar (+95)',
		NA: 'Namibia (+264)',
		NR: 'Nauru (+674)',
		NP: 'Nepal (+977)',
		NL: 'Netherlands (+31)',
		NC: 'New Caledonia (+687)',
		NZ: 'New Zealand (+64)',
		NI: 'Nicaragua (+505)',
		NE: 'Niger (+227)',
		NG: 'Nigeria (+234)',
		NU: 'Niue (+683)',
		NF: 'Norfolk Islands (+672)',
		NM: 'Northern Marianas (+670)',
		NO: 'Norway (+47)',
		OM: 'Oman (+968)',
		PW: 'Palau (+680)',
		PA: 'Panama (+507)',
		PG: 'Papua New Guinea (+675)',
		PY: 'Paraguay (+595)',
		PE: 'Peru (+51)',
		PH: 'Philippines (+63)',
		PL: 'Poland (+48)',
		PT: 'Portugal (+351)',
		PR: 'Puerto Rico (+1787)',
		QA: 'Qatar (+974)',
		RE: 'Reunion (+262)',
		RO: 'Romania (+40)',
		RU: 'Russia (+7)',
		RW: 'Rwanda (+250)',
		SM: 'San Marino (+378)',
		ST: 'Sao Tome &amp; Principe (+239)',
		SA: 'Saudi Arabia (+966)',
		SN: 'Senegal (+221)',
		CS: 'Serbia (+381)',
		SC: 'Seychelles (+248)',
		SL: 'Sierra Leone (+232)',
		SG: 'Singapore (+65)',
		SK: 'Slovak Republic (+421)',
		SI: 'Slovenia (+386)',
		SB: 'Solomon Islands (+677)',
		SO: 'Somalia (+252)',
		ZA: 'South Africa (+27)',
		ES: 'Spain (+34)',
		LK: 'Sri Lanka (+94)',
		SH: 'St. Helena (+290)',
		KN: 'St. Kitts (+1869)',
		SCL: 'St. Lucia (+1758)',
		SD: 'Sudan (+249)',
		SR: 'Suriname (+597)',
		SZ: 'Swaziland (+268)',
		SE: 'Sweden (+46)',
		CH: 'Switzerland (+41)',
		SY: 'Syria (+963)',
		TW: 'Taiwan (+886)',
		TJ: 'Tajikstan (+7)',
		TH: 'Thailand (+66)',
		TG: 'Togo (+228)',
		TO: 'Tonga (+676)',
		TT: 'Trinidad &amp; Tobago (+1868)',
		TN: 'Tunisia (+216)',
		TR: 'Turkey (+90)',
		TM: 'Turkmenistan (+7, +993)',
		TC: 'Turks &amp; Caicos Islands (+1649)',
		TV: 'Tuvalu (+688)',
		UG: 'Uganda (+256)',
		GB: 'UK (+44)',
		UA: 'Ukraine (+380)',
		AE: 'United Arab Emirates (+971)',
		UY: 'Uruguay (+598)',
		US: 'USA (+1)',
		UZ: 'Uzbekistan (+7)',
		VU: 'Vanuatu (+678)',
		VA: 'Vatican City (+379)',
		VE: 'Venezuela (+58)',
		VN: 'Vietnam (+84)',
		VG: 'Virgin Islands - British (+1284)',
		VI: 'Virgin Islands - US (+1340)',
		WF: 'Wallis &amp; Futuna (+681)',
		YE: 'Yemen (North)(+969)',
		YES: 'Yemen (South)(+967)',
		ZM: 'Zambia (+260)',
		ZW: 'Zimbabwe (+263)',
	},
	degrees: {
		college: 'College diploma',
		secondarySchool: 'Secondary school',
		bachelor: 'Bachelor',
		specialist: 'Specialist',
		master: 'Master',
		phd: 'PhD',
		incomplete: 'incomplete',
	},
	educationForms: {
		fullTime: 'очная',
		partTime: 'вечерняя',
		extramural: 'заочная',
		remote: 'дистанционная',
	},
	marital: {
		single: 'single — не в браке',
		official: 'marriage — официальный брак',
		commonLaw: 'common law — сожительство больше 12 месяцев',
		divorced: 'divorced — в разводе',
	},
	spouseMarital: {
		official: 'marriage — официальный брак',
		commonLaw: 'common law — сожительство больше 12 месяцев',
	},
	channels: {
		google: 'Поиск Google',
		ya: 'Поиск Yandex',
		forum: 'Форум',
		ig: 'Instagram',
		fb: 'Facebook',
		vk: 'ВКонтакте',
		socnet: 'Социальная сеть',
		referral: 'Рекомендация',
		other: 'Другое',
	},
	skills: {
		dontKnow: "Don't know",
		elementary: 'Elementary',
		preIntermediate: 'Pre-Intermediate',
		intermediate: 'Intermediate',
		upperIntermediate: 'Upper-Intermediate',
		advanced: 'Advanced',
	},
	provinces: {
		ontario: 'Ontario',
		quebec: 'Quebec',
		novaScotia: 'Nova Scotia',
		newBrunswick: 'New Brunswick',
		manitoba: 'Manitoba',
		britishColumbia: 'British Columbia',
		princeEdwardIsland: 'Prince Edward Island',
		saskatchewan: 'Saskatchewan',
		alberta: 'Alberta',
		newfoundlandAndLabrador: 'Newfoundland and Labrador',
		northwestTerritories: 'Northwest Territories',
		yukon: 'Yukon',
		nunavut: 'Nunavut',
	},
	relationships: {
		mother: 'mother',
		father: 'father',
		child: 'child',
		sister: 'sister',
		brother: 'brother',
		wife: 'wife',
		husband: 'husband',
		commonLaw: 'common law partner',
		halfBrother: 'half-brother/step-brother',
		halfSister: 'half-sister/step-sister',
		stepFather: 'step-father',
		stepMother: 'step-mother',
		stepSon: 'step-son',
		stepDaughter: 'step-daughter',
	},
};

export const timezone = {
	name: 'tz',
	en: 'Timezone',
	ru: 'Часовой пояс',
	options: selectOptions.timezones,
};

export const consTimezone = {
	name: 'tz',
	en: 'Winter/Summer',
	ru: 'Зима/Лето',
	options: selectOptions.consTimezones,
};

export const newSlots = {
	date: {
		name: 'date',
		en: 'Consultations date',
		ru: 'Дата консультаций',
		placeholder: 'Consultations date',
		type: 'date',
	},
	startTime: {
		name: 'startTime',
		en: 'Series start time',
		ru: 'Время начала серии консультаций',
		placeholder: 'Series start time',
	},
	count: {
		name: 'count',
		en: 'Series count',
		ru: 'Количество консультации в серии',
		placeholder: 'Series count',
		type: 'number',
	},
};

export const position = {
	name: {
		name: 'name',
		en: 'Name of company',
		ru: 'Название организации',
		placeholder: 'Name of company',
	},
	title: {
		name: 'title',
		en: 'Title',
		ru: 'Должность',
		placeholder: 'Title',
	},
	country: {
		name: 'country',
		en: 'Country',
		ru: 'Страна',
		options: selectOptions.countries,
	},
	city: {
		name: 'city',
		en: 'City',
		ru: 'Город',
		placeholder: 'City',
	},
	hoursPerWeek: {
		name: 'hoursPerWeek',
		en: 'Hours per week',
		ru: 'Часов в неделю',
		placeholder: 'Hours per week',
		type: 'number',
	},
	startDate: {
		name: 'startDate',
		en: 'Start of Employment',
		ru: 'Начало работы',
		placeholder: 'Start of Employment',
		type: 'date',
	},
	endDate: {
		name: 'endDate',
		en: 'End  of Employment',
		ru: 'Окончание работы',
		placeholder: 'End  of Employment',
		type: 'date',
	},
	isCurrent: {
		name: 'isCurrent',
		en: 'Current',
		ru: 'По настоящее время',
	},
};

export const school = {
	name: {
		name: 'name',
		en: 'Name of institute',
		ru: 'Название заведения',
		placeholder: 'Name of institute',
	},
	city: {
		name: 'city',
		en: 'City',
		ru: 'Город',
		placeholder: 'City',
	},
	country: {
		name: 'country',
		en: 'Country',
		ru: 'Страна',
		options: selectOptions.countries,
	},
	startDate: {
		name: 'startDate',
		en: 'Start of Education',
		ru: 'Начало обучения',
		placeholder: 'Start of Education',
		type: 'date',
	},
	endDate: {
		name: 'endDate',
		en: 'End of Education',
		ru: 'Окончание обучения',
		placeholder: 'End of Education',
		type: 'date',
	},
	degree: {
		name: 'degree',
		en: 'Degree/Diploma',
		ru: 'Степень/Диплом',
		options: selectOptions.degrees,
	},
	specialization: {
		name: 'specialization',
		en: 'Specialization',
		ru: 'Специальность',
		placeholder: 'Specialization',
	},
};

export const relative = {
	firstName: {
		name: 'firstName',
		en: 'First Name',
		ru: 'Имя',
		placeholder: 'First Name',
	},
	lastName: {
		name: 'lastName',
		en: 'Last Name',
		ru: 'Фамилия',
		placeholder: 'Last Name',
	},
	relationship: {
		name: 'relationship',
		en: 'Relationship',
		ru: 'Кем приходится',
		options: selectOptions.relationships,
	},
	birthDate: {
		name: 'birthDate',
		en: 'Birth Date',
		ru: 'Дата рождения',
		placeholder: 'Birth Date',
		type: 'date',
	},
	deathDate: {
		name: 'deathDate',
		en: 'Death date (if applicable)',
		ru: 'Дата смерти (если применимо)',
		placeholder: 'Death date (if applicable)',
		type: 'date',
	},
	birthCountry: {
		name: 'birthCountry',
		en: 'Birth Country',
		ru: 'Страна рождения',
		options: selectOptions.countries,
	},
	residenceCountry: {
		name: 'residenceCountry',
		en: 'Residence Country',
		ru: 'Страна проживания',
		options: selectOptions.countries,
	},
	city: {
		name: 'city',
		en: 'City of residence (or death)',
		ru: 'Город проживания (или смерти)',
		placeholder: 'City of residence (or death)',
	},
};

export const trip = {
	country: {
		name: 'country',
		en: 'Country',
		ru: 'Страна',
		options: selectOptions.countries,
	},
	cities: {
		name: 'cities',
		en: 'City(-ies)',
		ru: 'Город(а)',
		placeholder: 'City(-ies)',
	},
	startDate: {
		name: 'startDate',
		en: 'From',
		ru: 'С',
		placeholder: 'From',
		type: 'date',
	},
	endDate: {
		name: 'endDate',
		en: 'To',
		ru: 'По',
		placeholder: 'To',
		type: 'date',
	},
	purpose: {
		name: 'purpose',
		en: 'Purpose',
		ru: 'Цель поездки',
		placeholder: 'Purpose',
	},
};

export const residenceAddress = {
	zip: {
		name: 'zip',
		en: 'ZIP code',
		ru: 'Почтовый индекс',
		placeholder: 'ZIP code',
	},
	address: {
		name: 'address',
		en: 'Address',
		ru: 'Адрес',
		placeholder: 'Address',
	},
	startDate: {
		name: 'startDate',
		en: 'From',
		ru: 'С',
		placeholder: 'From',
		type: 'date',
	},
	endDate: {
		name: 'endDate',
		en: 'To',
		ru: 'По',
		placeholder: 'To',
		type: 'date',
	},
};

export const eeSchool = {
	...school,
	degree: {
		name: 'degree',
		en: 'Degree/Diploma',
		ru: 'Полученная степень (если есть)',
		placeholder: 'Degree/Diploma',
	},
	tuitionForm: {
		name: 'tuitionForm',
		en: 'Tuition Form',
		ru: 'Форма обучения',
		options: selectOptions.educationForms,
	},
};

export const languages = {
	englishSkills: {
		name: 'english_skills',
		en: 'English skills',
		ru: 'Знания английского',
		options: selectOptions.skills,
	},
	enCert: {
		name: 'ielts_celpip',
		en: 'IELTS/CELPIP results',
		ru: 'IELTS/CELPIP results',
		placeholder: 'IELTS/CELPIP results',
	},
	frenchSkills: {
		name: 'french_skills',
		en: 'French skills',
		ru: 'Знания французского',
		options: selectOptions.skills,
	},
	frCert: {
		name: 'tef_tcn',
		en: 'TEF/TCN results',
		ru: 'TEF/TCN results',
		placeholder: 'TEF/TCN results',
	},
};

export const core = {
	firstName: {
		name: 'first_name',
		en: 'First Name',
		ru: 'Имя',
		placeholder: 'First Name',
	},
	lastName: {
		name: 'last_name',
		en: 'Last Name',
		ru: 'Фамилия',
		placeholder: 'Last Name',
	},
	email: {
		name: 'email',
		en: 'E-mail',
		ru: 'Адрес E-mail',
		isDisabled: true,
	},
	phoneNumber: {
		name: 'phone_number',
		en: 'Phone #',
		ru: 'Номер телефона',
		placeholder: 'Phone #',
	},
	citizenship: {
		name: 'citizenship',
		en: 'Citizenship',
		ru: 'Гражданство',
		options: selectOptions.countries,
	},
	residence: {
		name: 'residence',
		en: 'Country of residence',
		ru: 'Страна проживания',
		options: selectOptions.countries,
	},
	city: {
		name: 'city',
		en: 'City',
		ru: 'Город проживания',
		placeholder: 'City',
	},
	birthDate: {
		name: 'birth_date',
		en: 'Date of Birth',
		ru: 'Дата рождения',
		placeholder: 'Date of Birth',
		type: 'date',
	},
	age: {
		name: 'age',
		en: 'Age',
		ru: 'Возраст',
		isDisabled: true,
	},
};

export const expressEntry = {
	lastName: {
		name: 'lastName',
		en: 'Last Name',
		ru: 'Фамилия',
		placeholder: 'Last Name',
	},
	previousNames: {
		name: 'previousNames',
		en: 'Previous Names',
		ru: 'Предыдущие фамилии (все)',
		placeholder: 'Previous Names (all of them)',
	},
	firstName: {
		name: 'firstName',
		en: 'First Name',
		ru: 'Имя',
		placeholder: 'First Name',
	},
	birthDate: {
		name: 'birthDate',
		en: 'Date of Birth',
		ru: 'Дата рождения',
		placeholder: 'Date of Birth',
		type: 'date',
	},
	birthPlace: {
		name: 'birthPlace',
		en: 'Birth place',
		ru: 'Место рождения',
		placeholder: 'Birth place',
	},
	zip: {
		name: 'zip',
		en: 'ZIP code',
		ru: 'Почтовый индекс',
		placeholder: 'ZIP code',
	},
	address: {
		name: 'address',
		en: 'Residence Address',
		ru: 'Адрес проживания (полный)',
		placeholder: 'Residence Address',
	},
	citizenship: {
		name: 'citizenship',
		en: 'Citizenship',
		ru: 'Гражданство',
		options: selectOptions.countries,
	},
	maritalStatus: {
		name: 'marital_status',
		en: 'Marital status',
		ru: 'Семейное положение',
		options: selectOptions.marital,
	},
	phoneNumber: {
		name: 'phoneNumber',
		en: 'Phone #',
		ru: 'Номер телефона',
		placeholder: 'Phone #',
	},
	eyesColor: {
		name: 'eyesColor',
		en: 'Eyes Color',
		ru: 'Цвет глаз',
		placeholder: 'Eyes Color',
	},
	height: {
		name: 'height',
		en: 'Height',
		ru: 'Рост',
		placeholder: 'Height',
	},
	emergencyContactLastName: {
		name: 'emergencyContactLastName',
		en: 'Last Name',
		ru: 'Фамилия',
		placeholder: 'Last Name',
	},
	emergencyContactfirstName: {
		name: 'emergencyContactfirstName',
		en: 'First Name',
		ru: 'Имя',
		placeholder: 'First Name',
	},
	emergencyContactPhoneNumber: {
		name: 'emergencyContactPhoneNumber',
		en: 'Phone #',
		ru: 'Номер телефона',
		placeholder: 'Phone #',
	},
	emergencyContactEmail: {
		name: 'emergencyContactEmail',
		en: 'E-mail',
		ru: 'Электронная почта',
		placeholder: 'E-mail',
	},
	priorVisaApplications: {
		name: 'priorVisaApplications',
		en: 'Prior Canada visa applications detailed, UCI if any',
		ru: 'Подавались ли вы когда-либо на канадскую визу/разрешение на учебу-работу или уже пытались иммигрировать? Если да, предоставьте подробности – на что подавались и уникальный номер клиента UCI',
		placeholder: 'Prior Canada visa applications detailed, UCI if any',
	},
	priorVisaRefusals: {
		name: 'priorVisaRefusals',
		en: 'Prior other visa refusals, detailed, if any',
		ru: 'Были ли отказы в любых других визах? Если да, то подробности.',
		placeholder: 'Prior other visa refusals, detailed, if any',
	},
	priorMarriages: {
		name: 'priorMarriages',
		en: 'Prior marriages information',
		ru: 'Информация о предыдущих браках',
		placeholder: 'Prior marriages information',
	},
	financialInfo: {
		name: 'financialInfo',
		en: 'Financial information',
		ru: 'Информация о финансовых средствах',
		placeholder: 'Financial information',
	},
	armyService: {
		name: 'armyService',
		en: 'Army service, detailed, if any',
		ru: 'Служба в армии (если да, то где когда, название части, города и звание)',
		placeholder: 'Army service, detailed, if any',
	},
	criminality: {
		name: 'criminality',
		en: 'Criminality',
		ru: 'Любые проблемы с законом. Закрытые/открытые уголовные дела, пьяное вождение',
		placeholder: 'Criminality',
	},
	priorRefugee: {
		name: 'priorRefugee',
		en: 'Prior refugee applications',
		ru: 'Подавались ли на беженство когда-либо где-либо?',
		placeholder: 'Prior refugee applications',
	},
	partyMembership: {
		name: 'partyMembership',
		en: 'Prior/current political party membership',
		ru: 'Состоите/состояли в какой-либо партии?',
		placeholder: 'Prior/current political party membership',
	},
	provinceToLive: {
		name: 'provinceToLive',
		en: 'In which Canada province you intend to live?',
		ru: 'В какой провинции Канады планируете жить',
		options: selectOptions.provinces,
	},
	cityToLive: {
		name: 'cityToLive',
		en: 'Which city',
		ru: 'В каком городе',
		placeholder: 'Which city',
	},
};

export const spouse = {
	...core,
	...languages,
	email: {
		name: 'email',
		en: 'E-mail',
		ru: 'Адрес электронной почты',
		placeholder: 'E-mail',
		type: 'email',
	},
};

export const sponsor = {
	...core,
	email: {
		name: 'email',
		en: 'E-mail',
		ru: 'Адрес электронной почты',
		placeholder: 'E-mail',
		type: 'email',
	},
	currentEmployment: {
		name: 'currentEmployment',
		en: 'Current employment',
		ru: 'Информация о текущей работе',
		placeholder: 'Current employment',
	},
	canadaPresence: {
		name: 'canadaPresence',
		en: 'Presence in Canada for last 24 months',
		ru: 'Сколько времени проживает в Канаде за последние 24 мес',
		placeholder: 'Presence in Canada for last 24 months',
	},
	priorSponsorships: {
		name: 'priorSponsorships',
		en: 'Are there prior spouse sponsorships (detailed)',
		ru: 'Были ли спонсорства супругов ранее (если да, предоставьте все подробности, включая, когда предыдущий супруг получил ПМЖ)',
		placeholder: 'Are there prior spouse sponsorships',
	},
	alimony: {
		name: 'alimony',
		en: 'Any alimony lawsuits',
		ru: 'Судился ли за неуплату алиментов',
		placeholder: 'Any alimony lawsuits',
	},
	bancruptcy: {
		name: 'bancruptcy',
		en: 'Does have declared bancruptcy?',
		ru: 'Имеет ли задекларированное банкротство?',
		placeholder: 'Does have declared bancruptcy?',
	},
	stateSupport: {
		name: 'stateSupport',
		en: 'Does receive any support from state?',
		ru: 'Получает ли в настоящее время какую-либо помощь от государства?',
		placeholder: 'Does receive any support from state?',
	},
};

export const sponsored = {
	...spouse,
	spouseMarital: {
		name: 'spouseMarital',
		en: 'Marital status',
		ru: 'Семейное положение',
		options: selectOptions.spouseMarital,
	},
	children: {
		name: 'children',
		en: 'Children',
		ru: 'дети до 22 лет, количество и возраст',
		placeholder: 'Children',
	},
	criminality: {
		name: 'criminality',
		en: 'Criminality',
		ru: 'Проблемы с законом у вас или супруга. В том числе открытые или закрытые уголовные дела, пьяное вождение',
		placeholder: 'Criminality',
	},
	healthIssues: {
		name: 'health_issues',
		en: 'Health issues',
		ru: 'Серьезные проблемы со здоровьем кого-либо из членов семьи',
		placeholder: 'Health issues',
	},
	canadaStatus: {
		name: 'canadaStatus',
		en: 'Sponsored spouse status in Canada',
		ru: 'Статус спонсируемого супруга в Канаде',
		placeholder: 'Sponsored spouse status in Canada',
	},
	together: {
		name: 'together',
		en: 'How long have you lived together and where?',
		ru: 'Как долго вы проживали совместно и где?',
		placeholder: 'How long have you lived together and where?',
	},
	separately: {
		name: 'separately',
		en: 'How long have you lived separately?',
		ru: 'Как долго вы проживали раздельно?',
		placeholder: 'How long have you lived separately?',
	},
	intentions: {
		name: 'intentions',
		en: 'Any intentions to enter into a legal marriage and when?',
		ru: 'Есть ли намеренья вступить в законный брак и когда?',
		placeholder: 'Any intentions to enter into a legal marriage and when?',
	},
	countryOfMarriage: {
		name: 'countryOfMarriage',
		en: 'Country of marriage',
		ru: 'Страна заключения брака',
		options: selectOptions.countries,
	},
	marriageDate: {
		name: 'marriageDate',
		en: 'Date of Marriage',
		ru: 'Дата заключения брака',
		placeholder: 'Date of Marriage',
		type: 'date',
	},
	isVisaOpen: {
		name: 'isVisaOpen',
		en: 'Does the sponsored spouse have a valid Canada visa?',
		ru: 'Есть ли у спонсируемого супруга открытая виза в Канаду?',
	},
	mutualKids: {
		name: 'mutualKids',
		en: 'Do you have mutual children?',
		ru: 'Есть ли совместные дети?',
	},
	whatElse: {
		name: 'whatElse',
		en: 'What else may confirm you relationship',
		ru: 'Что еще может подтвердить ваши отношения??',
		placeholder: 'What else may confirm you relationship',
	},
	docsSharedAccounts: {
		name: 'docsSharedAccounts',
		en: 'shared bank accounts and cards',
		ru: 'совместные банковские счета и кредитки',
	},
	docsFinHelp: {
		name: 'docsFinHelp',
		en: 'financial support proofs',
		ru: 'доказательства финансовой поддержки',
	},
	docsSharedRent: {
		name: 'docsSharedRent',
		en: 'shared apartment rent',
		ru: 'совместная аренда жилья',
	},
	docsSharedBills: {
		name: 'docsSharedBills',
		en: 'shared utility bills',
		ru: 'совместные счета за коммунальные платежи',
	},
	docsSharedPurchases: {
		name: 'docsSharedPurchases',
		en: 'shared purchases proofs',
		ru: 'подтверждение совместных покупок',
	},
	docsSharedMail: {
		name: 'docsSharedMail',
		en: 'mail to both of you at one address',
		ru: 'почта, адресованная обоим по одному адресу',
	},
	docsSharedPictures: {
		name: 'docsSharedPictures',
		en: 'pictures of you together',
		ru: 'совместные фото',
	},
	docsSharedTrips: {
		name: 'docsSharedTrips',
		en: 'shared trips',
		ru: 'совместные поездки',
	},
	docsSharedLogins: {
		name: 'docsSharedLogins',
		en: 'emails, social networks',
		ru: 'емейлы, соцсети',
	},
	docsCallLogs: {
		name: 'docsCallLogs',
		en: 'call logs',
		ru: 'история звонков',
	},
};

export const fields = {
	...core,
	...languages,
	critical: {
		name: 'critical',
		en: 'Critical Info',
		ru: 'Важнейшая информация',
		placeholder: 'Critical Info',
	},
	maritalStatus: {
		name: 'marital_status',
		en: 'Marital status',
		ru: 'Семейное положение',
		options: selectOptions.marital,
	},
	children: {
		name: 'children',
		en: 'Children',
		ru: 'дети до 22 лет, количество и возраст',
		placeholder: 'Children',
	},
	criminality: {
		name: 'criminality',
		en: 'Criminality',
		ru: 'Проблемы с законом у вас или супруга. В том числе открытые или закрытые уголовные дела, пьяное вождение',
		placeholder: 'Criminality',
	},
	healthIssues: {
		name: 'health_issues',
		en: 'Health issues',
		ru: 'Серьезные проблемы со здоровьем кого-либо из членов семьи',
		placeholder: 'Health issues',
	},
	visaRefusals: {
		name: 'visa_refusals',
		en: 'Any previous visa refusals',
		ru: 'Предыдущие отказы в любых визах любых стран',
		placeholder: 'Any previous visa refusals',
	},
	tripsAbroad: {
		name: 'trips_abroad',
		en: 'Trips abroad for the last 5 years',
		ru: 'Заграничные поездки за последние 5 лет. В том числе безвизовые страны. Шенген - одна страна',
		placeholder: 'Trips abroad for the last 5 years',
	},
	relatives: {
		name: 'relatives',
		en: 'Relatives in Canada',
		ru: 'Родственники в Канаде. Укажите родство и провинцию, в которой проживают',
		placeholder: 'Relatives in Canada',
	},
	questions: {
		name: 'questions',
		en: 'Questions',
		ru: 'Вопросы для консультации',
		placeholder: 'Questions',
	},
	financial: {
		name: 'financial',
		en: 'Financial potential, CAD',
		ru: 'Максимум средств, которые можете показать на счетах, в канадских долларах',
		placeholder: 'Financial potential',
	},
	channel: {
		name: 'channel',
		en: 'How did you know about CanadaMania',
		ru: 'Как вы узнали обо мне и моей компании',
		options: selectOptions.channels,
	},
	channelDetails: {
		name: 'channel_details',
		en: 'Which exactly',
		ru: 'А именно',
		placeholder: 'Which exactly',
	},
};
